import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { PersonType, PersonTypeString } from '@infrastructure/Models/const.personType';
import ArrayHelpers from '@infrastructure/ArrayHelper';
import { BeneficiaryDeleteService } from '@infrastructure/Beneficiaries/beneficiary-delete.service';
import { LegalRepresentationStateService, LegalRepresentationState } from '@infrastructure/Beneficiaries/legal-representation-state.service';
import { StateCode, StatePhase } from '@infrastructure/Models/const.stateCodePhase';


@Component({
  selector: 'representados-list-pre-stage',
  templateUrl: './representados-list-pre-stage.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => RepresentadosListPreStageComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class RepresentadosListPreStageComponent implements OnInit, OnDestroy, OnChanges {

  @Input() model: models.BeneficiaryVM;
  
  @Input() nifDeceased: number;
  @Input() nifRepresentanteLegal: number;
  @Input() documentsList: models.DocumentVM_PM[];
  @Input() isSenderBeneficiary: boolean;

  @Input() estadoPendente: boolean;
  @Input() isBeneficiary: boolean;
  @Input() isLegalRepresentative: boolean;
  @Input() stateCode: string;
  @Input() statePhase: string;
  
  @Output() isOnEdit = new EventEmitter<boolean>();
  @Output() documentsListChanged = new EventEmitter<models.DocumentVM_PM[]>();

  
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];

  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  @Input() dropdowns: models.WorkflowDropdownsVM = {} as models.WorkflowDropdownsVM;

  public expandNewBeneficiary: boolean = false;
  public expandedRowIndex: number = null;
  public estadoDevolvidoAoRemetente: boolean;

  constructor(private http: HttpClient,
    private activeRoute: ActivatedRoute,
    private modalService: ModalService,
    private beneficiaryDeleteService: BeneficiaryDeleteService,
    private legalRepresentationState: LegalRepresentationStateService,
    private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      const a = 1;
    }
  }
 
  ngAfterViewChecked(): void {
    this.estadoDevolvidoAoRemetente = this.stateCode == StateCode.Ativo && this.statePhase == StatePhase.DevolvidoAoRemetente;
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {

  }


  ngOnDestroy(): void {//const workflowCode = parseInt(this.workflowVersion) < 3 ? this.workflowCode : this.workflowCode;
    //return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: workflowCode } })
  }

  private onCardDataChanged() {


  }

  public getIconEditar(isExpanded: boolean): string {
    if (isExpanded) {
      return 'icon-close';
    } else {
      if (this.estadoPendente) {
        return 'icon-more';
      } else {
        return 'icon-edit';
      }
    }
  }

  public isNotSender(tableItem: models.BeneficiaryListVM): boolean {
    let result = true;
    if (tableItem.beneficiaryID == 1) {
      result = false;
    }
    return result;
  }
  public isRepresentadoButNotBeneficiary(item: models.BeneficiaryListVM): boolean {
    let result = true;
    result = (item.NIF != this.nifRepresentanteLegal) ||
      (this.isBeneficiary?.toString() != 'true' && this.isLegalRepresentative?.toString()=='true')
    return result;
  }

  public getStateColor(state: string): string {
    return this.legalRepresentationState.getStateColor(state?.toString());
  }

  public getStateText(state: string): string {
    return this.legalRepresentationState.getStateText(state?.toString());
  }

  onBeneficiaryChanged(newList: models.BeneficiaryListVM[]) {
    this.model.beneficiaryList = newList;
    this.expandNewBeneficiary = false;
    this.expandedRowIndex = null;


  }

  expandNewItem(newItem: boolean) {
    this.isOnEdit.emit(true);
  }

  isClosingAction() {
    this.isOnEdit.emit(false);
  }
  onEdit(isEdit: boolean) {
    const a = this.expandedRowIndex
  }

  removeFromList(tableItem: models.BeneficiaryListVM, indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      //Ao eliminar o último representado da lista num pedido no estado Ativo|Devolvido ao Remetente deve aparecer um pop up impeditivo com mensagem
      if (this.stateCode == StateCode.Ativo && this.statePhase == StatePhase.DevolvidoAoRemetente) {
          let showModal= false;
          if (this.isBeneficiary) {
            const copyList = [...this.model.beneficiaryList];
            const indexOf = copyList
              .findIndex(el => el.beneficiaryID == tableItem.beneficiaryID);
            if (indexOf > -1) {
              copyList.splice(indexOf, 1);
            }
            // Testa se só resta o remetente (habilitanto com beneficiaryID igual a 1)
            if (copyList.length === 1 && copyList[0].beneficiaryID === 1) {
              showModal = true;
            } else {
              if (tableItem.stateRL == LegalRepresentationState.RepresentaçaoAguardarDocumentos) {
                showModal = false;
              } else {
                showModal = true;
              }
            }
          } else {
            if (this.model.beneficiaryList?.length == 1 && this.model.beneficiaryList[0].beneficiaryID === tableItem.beneficiaryID) {
              showModal = true;
            } else {
              if (tableItem.stateRL == LegalRepresentationState.RepresentaçaoAguardarDocumentos) {
                showModal = false;
              } else {
                showModal = true;
              }
            }
          }   
          if (showModal) {
            let modal = <models.BaseModalVM>{
              isError: false,
              message: "WorkflowCreatePM.PreStage.CardRepresentados.LastRepresentativeAlert",
              param: {},
              cancelButton: {
                hideButton: true,
                buttonText: "Ok",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              }
            };

            this.modalService.showModals([modal]).subscribe(result => {
              return;
            });
            return;
          }
        
      }

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.ConfirmaRemover",
        param: {},
        //cancelButton: {
        //  hideButton: true,
        //  buttonText: "Ok",
        //  buttonClass: 'btn-primary',
        //  iconClass: "icon-check"
        //}
      };

      this.modalService.showModals([modal]).subscribe(result => {
        if (result) {
          this.expandedRowIndex = null;

          const result =this.beneficiaryDeleteService.removeBeneficiaryFromList(
            tableItem, this.model.beneficiaryList, this.documentsList
          );

          this.model.beneficiaryList = result.beneficiaryList;
          this.documentsList = result.documentsList;
          this.documentsListChanged.emit(this.documentsList);

        }
      });
    }
    event.stopPropagation();
  }





  hasOtherThanSender(): boolean {
    const nifSender = this.nifRepresentanteLegal;
    if (nifSender == null || nifSender == undefined) {
      return this.model.beneficiaryList.length > 0;
    }
    let otherBeneficiaries = this.model.beneficiaryList
      .filter(el => el.NIF != nifSender);
    const isRLAndNotBeneficiary = (this.isBeneficiary?.toString() != 'true' && this.isLegalRepresentative?.toString() == 'true')
    return otherBeneficiaries.length > 0 || isRLAndNotBeneficiary;
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
    this.expandNewItem(true);
  }

  public benefitLabelAppearingFunction(survivalPensionBenefit, reimbursementFuneralBenefit, funeralAllowanceBenefit): String {
    let benefits: String[] = []
    if (typeof survivalPensionBenefit !== "undefined" && survivalPensionBenefit) {
      benefits.push("Pensão de sobrevivência")
    }

    if (typeof reimbursementFuneralBenefit !== "undefined" && reimbursementFuneralBenefit) {
      benefits.push("Reembolso de despesas de funeral")
    }

    if (typeof funeralAllowanceBenefit !== "undefined" && funeralAllowanceBenefit) {
      benefits.push("Subsídio de morte")
    }

    return benefits.join(", ")
  }

  public legalRepresentationLabelAppearingFunction(legalRepresentation: String): String {
    if (legalRepresentation?.toString() == 'true') {
      return "Sim"
    } else if (legalRepresentation?.toString() == 'false') {
      return "Não"
    } else {
      return ""
    }
  }

  public representationTypeLabelAppearingFunction(representationType): String {
    const representationTypes = this.dropdowns.options.filter(el => el.dropdown == "DropdownRepresentationType");
    return representationTypes.find(el => el.value == representationType).description;

  }
}
